import { Button, Card, Text } from "../../../../components";
import { AlarmListLayout } from "../../../../layouts";
import Localization from "../../../../localization";
import useViewModel from "../../viewModel";
import { Enums } from "../../../../utils";
import AlarmModel from "./alarmModel";
import Verisure from "./verisure";
import { useMemo } from "react";
import Webhook from "./webhook";
import Phone from "./phone";
import { Flex } from "antd";
import Ajax from "./ajax";

const AlarmConnection = ({
  onEditClick = () => {},
  title = Localization.service.card_2_title,
  ...props
}) => {
  const { isConfigured, isDeviceTypeEditable, alarmModel } = useViewModel();

  const isIntegration = alarmModel.type === "integration";

  const alarmConnectionError = {
    [Enums.deviceIntegrations.sms]: {
      title: Localization.service.card_2_footer_sms_title,
      desc: Localization.service.card_2_footer_sms_desc,
    },
    [Enums.deviceIntegrations.ajax]: {
      title: Localization.service.card_2_footer_ajax_title,
      desc: Localization.service.card_2_footer_ajax_desc,
    },
  }[alarmModel?.integration];

  const alarmComponent = useMemo(() => {
    switch (alarmModel?.integration) {
      case Enums.deviceIntegrations.ajax:
        return <Ajax alarmModel={alarmModel} />;
      case Enums.deviceIntegrations.verisure:
        return <Verisure alarmModel={alarmModel} />;
      case Enums.deviceIntegrations.http:
        return <Webhook alarmModel={alarmModel} isConfigured={isConfigured} />;
      case Enums.deviceIntegrations.sms:
        return (
          <Phone
            alarmModel={alarmModel}
            isIntegration={isIntegration}
            isConfigured={isConfigured}
          />
        );
      default:
        return null;
    }
  }, [alarmModel, isIntegration]);

  return (
    <Card
      {...props}
      classNames={{ header: `p-${isIntegration ? 20 : 30}-b` }}
      title={title}
      extra={
        isConfigured &&
        isIntegration &&
        alarmModel.image && (
          <img style={{ height: "4rem" }} src={alarmModel.image} />
        )
      }
    >
      {!alarmComponent ? (
        <AlarmListLayout.Other />
      ) : (
        <>
          {alarmComponent}
          <Flex gap={"1rem"} className="m-30-t">
            {isDeviceTypeEditable(alarmModel) && (
              <Button
                type="primary"
                minWidth={"8.5rem"}
                onClick={() => onEditClick({ type: "edit" })}
                title={Localization.general.edit}
              />
            )}
            <Button
              type="primary"
              onClick={() => onEditClick({})}
              title={Localization.service.edit_alarm_connection_btn_2}
            />
            {!!alarmModel.readUrl && (
              <Button
                title={Localization.general.how_it_works}
                onClick={() => window.open(alarmModel.readUrl)}
              />
            )}
          </Flex>
        </>
      )}
      {!!alarmConnectionError && !alarmModel?.identifier && (
        <div className="m-30-t">
          <Text level={5} weight={600} children={alarmConnectionError?.title} />
          <Text className="m-5-t" children={alarmConnectionError?.desc} />
        </div>
      )}
    </Card>
  );
};

AlarmConnection.AlarmModel = AlarmModel;

export default AlarmConnection;
